import React, { useEffect } from 'react';
import { get } from 'lodash';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';

import {
  setEpargnDetailsPageBreadcrumbsPath,
  getFaq,
} from 'store/global/actions';
import {
  getEpargnDetailsPageSelectedTabValue,
  getEpargnDetailsPageBreadcrumbsPathSelector,
  getEpargnFaqSelector,
} from 'store/global/selectors';
import { breadcrumbsItemType } from 'store/global/types';
import DetailPageLayout from 'components/DetailPageLayout';
import ContainerTabs from 'components/ContainerTabs';
import { AssuranceIcon } from 'images';
import Breadcrumbs from 'components/Breadcrumbs';
import { translate } from 'helpers/intl';
import messages from 'containers/EpargnDetailsPage/messages';
import { StyledMediumSectionHeader } from 'containers/AutoDetailsPage/styles';
import PAGES from 'routes/pages';
import MyOffers from 'containers/EpargnDetailsPage/MyOffers';
import Faq from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import { sanlamDarkBlue } from 'Material-UI/colors';
import { getContractsEpargn } from 'store/contract/actions';
import MyContractsEpargn from 'containers/EpargnDetailsPage/ContractsBloc';
import ReleveSituation from 'containers/EpargnDetailsPage/ReleveSituation';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
const tabItems = [
  {
    label: 'mesReleveDeSituation',
    content: <ReleveSituation />,
    category: EVENT_CATEGORIES.EPARGN_DETAILS,
    gaLabel: 'Mes RDS_Tab 1_Mes relevés de situation',
  },
  {
    label: 'mesContrats',
    content: <MyContractsEpargn />,
    category: EVENT_CATEGORIES.EPARGN_DETAILS,
    gaLabel: 'Mes contrats_Tab 2_Mes contrats',
  },
];

const EpargnDetailsPage = (props: {
  setEpargnDetailsPageBreadcrumbsPath: Function;
  selectedTabValue: number;
  detailsPageBreadcrumbsPath: breadcrumbsItemType[];
  intl: IntlShape;
  getContractsEpargn: Function;
  getFaq: Function;
  faqEpargn: [];
}) => {
  const HeaderTextBloc = (
    <>
      <StyledMediumSectionHeader>
        {translate(get(messages, 'title'), props)}
      </StyledMediumSectionHeader>
    </>
  );
  const language = useSelector(getLocaleSelector);

  /* eslint-disable */
  useEffect(() => {
    props.getContractsEpargn();
  }, [props.getContractsEpargn]);
  /* eslint-enable */
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);
  return (
    <DetailPageLayout
      headerImage={get(AssuranceIcon, 'headerEpargn')}
      HeaderTextBloc={HeaderTextBloc}
      Breadcrumbs={<Breadcrumbs path={props.detailsPageBreadcrumbsPath} />}
      TabsBloc={
        <ContainerTabs
          tabItems={tabItems}
          setBreadcrumbsPath={props.setEpargnDetailsPageBreadcrumbsPath}
          rootPath={[{ name: 'epargn', route: PAGES.EPARGN_DASHBOARD }]}
          selectedTabValue={props.selectedTabValue}
        />
      }
      FAQBloc={
        <Faq
          items={
            props.faqEpargn &&
            props.faqEpargn.map(
              (
                item: { question: string; code: string; id: number },
                index: number,
              ) => ({
                title: (
                  <StyledShortBody
                    weight="bold"
                    color={sanlamDarkBlue}
                    key={index}
                  >
                    {item.question}
                  </StyledShortBody>
                ),
                path: '/faq',
                id: item.id,
                code: item.code,
                isFaq: true,
                category: EVENT_CATEGORIES.EPARGN_ACCUEIL,
                label: item.question,
              }),
            )
          }
          GACategoryAllResponses={EVENT_CATEGORIES.EPARGN_ACCUEIL}
        />
      }
      MyOffersBloc={<MyOffers />}
    />
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    detailsPageBreadcrumbsPath: breadcrumbsItemType[];
    selectedTabValue: number;
    faqEpargn: [];
  }
>({
  detailsPageBreadcrumbsPath: getEpargnDetailsPageBreadcrumbsPathSelector,
  selectedTabValue: getEpargnDetailsPageSelectedTabValue,
  faqEpargn: getEpargnFaqSelector,
});

const mapDispatchToProps = {
  setEpargnDetailsPageBreadcrumbsPath,
  getContractsEpargn,
  getFaq,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EpargnDetailsPage));

export { EpargnDetailsPage as EpargnDetailsPageTest };
